import { render, staticRenderFns } from "./CourseCombination.vue?vue&type=template&id=2e0d2a53&"
import script from "./CourseCombination.vue?vue&type=script&lang=js&"
export * from "./CourseCombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports